import { useEffect, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import { Content, DateSelectContainer, DateSelector, SubTitle, TimeDDL } from './SickPeriod.styled';
import moment from 'moment';
import { useStore } from '@store/appStore';
import db from '@utils/db';
import DateSelect from './DateSelect';
import Cal_Icon from "@assets/svg/new_calendar.svg"

interface IProps {
  selectFromDate: (type, date) => void,
  selectedFromDate: any,
  selectedToDate: any,
  selectToDate: (date) => void
}

export const SickPeriod = (props: IProps) => {
  const { client } = useStore();
  const i18n = useI18n();


  useEffect(() => {
    let t = moment(props.selectedFromDate).add(1, 'days')
    if(props.selectedToDate === null)props.selectToDate(t.toDate())
  }, [])

  const getTime = () => {
    let times = []
    for (let i = 8; i < 20; i++) {
      times.push(<option>{(i < 10 ? ("0" + i) : i) + ":00"}</option>)
      times.push(<option>{(i < 10 ? ("0" + i) : i) + ":15"}</option>)
      times.push(<option>{(i < 10 ? ("0" + i) : i) + ":30"}</option>)
      times.push(<option>{(i < 10 ? ("0" + i) : i) + ":45"}</option>)
    }
    return times
  }

  const handleDate = (type, date) => {
    if (type === 1) {
      let t = moment(props.selectedToDate)
      let d = moment(date)
      props.selectFromDate(1, date)
      if (t.isBefore(d, 'date')) {
        d = moment(d)
        d.add(1, 'day')
        props.selectToDate(d.toDate())
      }
    }
    else {
      let t = moment(props.selectedToDate)
      let d = moment(date)
      props.selectToDate(d.toDate())
      if (t.isAfter(d, 'date')) {
        let today = moment()
        d = moment(d)
        if (d.isAfter(today, 'date'))
          d.add(-1, 'day')
        props.selectFromDate(1, d.toDate())
      }
    }
  }


  return (<>

    <Content>
      <DateSelectContainer span={true}>
        <SubTitle>Start dato: </SubTitle>
        <DateSelect type={1} value={props.selectedFromDate} setDate={handleDate}>
          <DateSelector><span>{moment(props.selectedFromDate).format("DD-MM-YYYY")}</span><Cal_Icon /></DateSelector>
        </DateSelect>
        {//<TimeDDL>{getTime()}</TimeDDL>
        }

        <SubTitle>Slut dato:</SubTitle>
        <DateSelect type={2} value={props.selectedToDate} setDate={handleDate}>
          <DateSelector><span>{moment(props.selectedToDate).format("DD-MM-YYYY")}</span><Cal_Icon /></DateSelector>
        </DateSelect>
        {//<TimeDDL>{getTime()}</TimeDDL>
        }
      </DateSelectContainer>
    </Content>
  </>);
};

export default SickPeriod;
